import { AppService } from './app.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
var FooComponent = /** @class */ (function () {
    function FooComponent(_router, _service, spinnerService) {
        this._router = _router;
        this._service = _service;
        this.spinnerService = spinnerService;
        this.url = "";
        this.msg = "";
        // private foosUrl = '/api/foos/';
        this.meUrl = '/api/user/me';
        this.typeSelected = 'ball-fussion';
    }
    // getStatus(id) {
    //     // http://localhost:8088/api/idcheck/status/
    //     this._service.getResource("/api/idcheck/status/" + id)
    //         .subscribe(
    //             data => {
    //                 console.log(data);
    //                 this.msg = 'Status: ' + data.result['status'];
    //                 this.pending = data.result['status'] === 'PENDING_MANUAL_REVIEW'
    //                 if (data.result && data.result['status'] === 'COMPLETED' || data.result['status'] === 'COMPLETED_FRAUD') {
    //                     this.complete = true;
    //                 } else {
    //                     this.complete = false;
    //                     if(!this.pending)this.getNfcTransactionId();
    //                 }
    //                 //data['result'] = {}
    //                 //data['result].status = result.status = data['status'];
    //                 //const result = JSON.stringify(data);
    //                 // console.log(data);
    //             },
    //             error => this.msg = 'Error getting Status: ' + error.errorMessage);
    // }
    FooComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.spinnerService.show();
        this._service.checkCredentials();
        // this.getMe();
        this._service.getResource('/api/idcheck/status')
            .subscribe(function (data) {
            _this.foo = data;
            var nfc = data &&
                data.result &&
                data.result['documentVerification'] &&
                data.result['documentVerification'].documents &&
                data.result['documentVerification'].documents[0] &&
                data.result['documentVerification'].documents[0].nfc;
            if (data && data.result) {
                _this.msg = 'Status: ' + data.result['status'];
                _this.pending = data.result['status'] === 'PENDING_MANUAL_REVIEW';
                // if (data.result && nfc && data.result['status'] === 'COMPLETED' || data.result['status'] === 'COMPLETED_FRAUD') {
                if (data.result && data.result['status'] === 'COMPLETED' || data.result['status'] === 'COMPLETED_FRAUD') {
                    _this.complete = true;
                }
                else {
                    _this.complete = false;
                    if (!_this.pending)
                        _this.getNfcTransactionId();
                }
            }
            else {
                _this.complete = false;
                _this.getNfcTransactionId();
            }
            _this.spinnerService.hide();
        }, function (error) {
            console.log(error);
            _this.spinnerService.hide();
        });
    };
    FooComponent.prototype.getMe = function () {
        var _this = this;
        this._service.getResource(this.meUrl)
            .subscribe(function (data) {
            _this.me = data;
            localStorage.setItem('currentUser', JSON.stringify(data));
            _this.isPaymentsEnabled = _.get(data, 'bank_user_id') ? true : false;
            if (_this.isPaymentsEnabled)
                _this.getWallet();
            console.log("me: ", data);
        }, function (error) { return _this.msg = 'Error getting current user: ' + error.errorMessage; });
    };
    FooComponent.prototype.getWallet = function () {
        var _this = this;
        this._service.getResource("/api/user/wallets/" + _.get(this.me, 'bank_user_id'))
            .subscribe(function (data) {
            if (data[0]) {
                _this.currentWallet = data[0];
            }
            else {
                alert("Your permission for Payments is under review!");
            }
            //data['result'] = {}
            //data['result].status = result.status = data['status'];
            //const result = JSON.stringify(data);
            console.log(data);
        }, function (error) { return _this.msg = 'Error getting wallet: ' + error.errorMessage; });
    };
    FooComponent.prototype.getTransactionId = function () {
        var _this = this;
        console.log("getTransactionId");
        this.spinnerService.show();
        this._service.getTransactionId()
            .subscribe(function (data) {
            // console.log(data['data']['transactionCode'], JSON.stringify(data))
            location.href = environment.pxlApiServer + "/?tc=" + data + "&oi=" + environment.pxlOiUrl;
        }, function (error) { return _this.msg = 'Error getting pxl transaction id: ' + error.errorMessage; });
    };
    FooComponent.prototype.getNfcTransactionId = function () {
        var _this = this;
        console.log("getNfcTransactionId");
        this.spinnerService.show();
        this._service.getNfcTransactionId()
            .subscribe(function (data) {
            // console.log(data['data']['transactionCode'], JSON.stringify(data))
            location.href = environment.pxlApiServer + "/?tc=" + data + "&oi=" + environment.pxlOiUrl;
        }, function (error) { return _this.msg = 'Error getting pxl transaction id: ' + error.errorMessage; });
    };
    FooComponent.prototype.wallet = function () {
        this._router.navigateByUrl('/wallet');
    };
    FooComponent.prototype.topup = function () {
        this._router.navigateByUrl('/topup');
    };
    FooComponent.prototype.questionaire = function () {
        console.log("questionaire");
        this._router.navigateByUrl('/questionaire');
        /*
        this.spinnerService.show();
        this._service.enablePayments("")
            .subscribe(
                data => {
                     console.log(JSON.stringify(data))

                },
                error => this.msg = 'Error');
        */
    };
    FooComponent.prototype.calculate_age = function (d) {
        var dob = new Date(d);
        var diff_ms = Date.now() - dob.getTime();
        var age_dt = new Date(diff_ms);
        return Math.abs(age_dt.getUTCFullYear() - 1970);
    };
    FooComponent.prototype.expired = function (d) {
        var quoteExpiry = new Date(d).getTime();
        var now = new Date();
        return (now.getTime() > quoteExpiry) ? true : false;
    };
    FooComponent.prototype.scan = function () {
        this._router.navigate(['/scan', ""]);
    };
    FooComponent.prototype.refreshPage = function () {
        location.reload();
    };
    return FooComponent;
}());
export { FooComponent };
